import { DataBean } from "../DataBean";

export class AnnotationReport extends DataBean {


    public async getAnnotationReportCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getAnnotationReportCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getAnnotationReportCatalogPorPropiedadesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getAnnotationReportCatalogPorPropiedadesRender_java.util.Map_Number", [properties,maxRows]);
    }


 
}